import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftsqlserverComponent } from './simple-icons-microsoftsqlserver.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftsqlserverComponent ],
    exports:      [ SimpleIconsMicrosoftsqlserverComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftsqlserverModule {}
